import React from "react";
import PropTypes from "prop-types";
import { ChartLegend } from "@progress/kendo-react-charts";

/**
 * ChartLegendComponent
 * @class
 * @property {object} legendProps - Props of module ChartLegend
 */

/**
 * ChartLegend
 * @module
 * @property {string} position - Position
 */

const ChartLegendComponent = (props) => {
  const { legendProps } = props;
  return <ChartLegend position={legendProps.position} />;
};

ChartLegendComponent.propTypes = {
  legendProps: PropTypes.shape({
    position: PropTypes.string,
  }),
};

export default ChartLegendComponent;
